import { useTranslation } from 'react-i18next'
import { AVAILABLE_LANGUAGES } from '../i18n'

export const useLanguages = () => {
    const { i18n } = useTranslation()
    const { resolvedLanguage, language } = i18n
    const userLang = { ...AVAILABLE_LANGUAGES[resolvedLanguage ?? 'es'], language, resolvedLanguage }

    return { langs: AVAILABLE_LANGUAGES, userLang }
}
